import { asNumber } from "@/lib/utils";
import { queryClient } from "@/state/router";
import { savedPageSize } from "@/components/custom/data-table/table-settings/table-settings-search";
import {
  SESSIONS_DEFAULT_PAGE_SIZE,
  SESSIONS_PAGE_OPTIONS,
  SESSIONS_TABLE_KEY,
} from "./-sessions-search";

/**
 * The Sessions routes' `limit` for validateSearch: the URL's own value, else the page size saved to
 * the user's profile (ID-6898), else the default. The router validates a URL before it loads, with
 * /me already cached (primed on boot, kept fresh by the app afterwards), so the saved size is in
 * the URL before the page renders -- see table-settings-search.ts.
 */
export const sessionsLimit = (search: Record<string, any>): number =>
  asNumber(search?.limit) ??
  savedPageSize(queryClient, SESSIONS_TABLE_KEY, SESSIONS_PAGE_OPTIONS) ??
  SESSIONS_DEFAULT_PAGE_SIZE;
